module.exports = __webpack_public_path__ + "static/media/ucc_label_icon_disabled.78f842b7.svg";